import React from 'react'

import { Partners } from 'components'
import { Separator } from 'shared/components'
import { Info } from './Info/Info'
import { Map } from './Map/Map'

import classes from './Contacts.module.scss'

export const Contacts = (): JSX.Element => {
  return (
    <div>
      <Info />
      <Map />
      <Separator className={classes.separator} />
      <Partners />
      <Separator className={classes.separator} />
    </div>
  )
}
